import { render, staticRenderFns } from "./pushModal.vue?vue&type=template&id=57a4780d&scoped=true&"
import script from "./pushModal.vue?vue&type=script&lang=js&"
export * from "./pushModal.vue?vue&type=script&lang=js&"
import style0 from "./pushModal.vue?vue&type=style&index=0&id=57a4780d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a4780d",
  null
  
)

export default component.exports